
























































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { VPopover } from 'v-tooltip'
import { mdiInformationOutline } from '@mdi/js'
import { IStyle } from '~/assets/interfaces/classes'
import '~/assets/scss/v-tooltip.scss'
import ComponentCatalogFilterInfo from '~/components/catalog/filter/catalog-filter-info.vue'
import ComponentIcon from '~/components/icon/icon.vue'

interface IParamItem {
  title: string
  url?: string
  value: string
  info?: string
}

interface IParamBlock {
  title: string
  items: IParamItem[]
}

@Component({
  components: {
    ComponentIcon,
    ComponentCatalogFilterInfo,
    VPopover,
  },
})
export default class ComponentProductParams extends Vue {
  @Prop({ type: Array, default: () => [] }) private items!: IParamBlock[]

  private icons = {
    mdiInformationOutline,
  }

  private mounted(): void {
    this.$emit('loaded')
  }

  private paramItems(list: any[], column: number = 1) {
    if (this.$device.isMobileOrTablet) {
      return list
    }
    const length = list.length
    const start = Math.ceil(length / 2) * (column - 1)
    const end = start + Math.ceil(length / 2)
    return list.slice(start, end)
  }

  private $style!: IStyle

  private get classParamsItemList() {
    return {
      [this.$style.paramsItemList]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }
}
